// SSOT: 펫 모델 카탈로그 (modelCatalog.json). key = 모델 id(소문자), value = { model_url, thumb_color, name, is_available }.
//  순서 = 표시 순서(JSON 키 순서 보존). 흩어져 있던 이름/체험여부/썸네일색/경로버전을 이 한 곳으로 통합.
//  펫은 이제 pet_profile에 id(예 "bear")를 저장하고, 재생 직전 호출측에서 idToModelUrl로 model_url을 해석한다.
//  일부 동물(lion/tiger/bear/fox)은 model_url이 v5 경로 — 카탈로그가 동물별 버전을 결정(SSOT).
import MODEL_CATALOG from "./modelCatalog.json";
export { MODEL_CATALOG };

// 파생 — 기존 소비자 호환 (순서 보존, id=소문자 modelIndex)
export const ALL_MODEL_INDEXES = Object.keys(MODEL_CATALOG);

// 펫 선택 UI용 메타 배열: [{ modelIndex, name, isAvailable }]  (is_available → isAvailable 매핑)
export const MODEL_METAS = ALL_MODEL_INDEXES.map((modelIndex) => ({
  modelIndex,
  name: MODEL_CATALOG[modelIndex].name,
  isAvailable: MODEL_CATALOG[modelIndex].is_available,
}));

// 동물 id → 썸네일 평균색 (카탈로그 파생, 기존 소비자 호환)
export const MODEL_THUMB_COLOR = ALL_MODEL_INDEXES.reduce((o, id) => {
  o[id] = MODEL_CATALOG[id].thumb_color;
  return o;
}, {});

// 모델 참조(id 또는 커스텀 경로) → CDN model_url.
//  카탈로그 id면 매핑된 model_url(v5/v6 동물별), 없으면 그대로 통과(커스텀/레거시 경로).
export function idToModelUrl(ref) {
  if (!ref) return ref;
  const e = MODEL_CATALOG[ref];
  return e ? e.model_url : ref;
}
// 하위호환 별칭 (구 buildModelUrl 호출부 유지) — id/경로 모두 안전 처리.
export const buildModelUrl = idToModelUrl;

// CDN 호스트 (R2 virtupet-cdn → cdn.virtupet.tv). 모델/방송 리소스 공통.
export const CDN_HOST = process.env.VUE_APP_CDN_HOST_URL || "";

// 방송 리소스(R2 `resources/...`) 절대 URL 빌드.
//  relPath 예: "musics/kokain.mp3", "sounds/quack.wav", "lotties/background/x.json"
//  (구 `/broadcast-resources/...` public 경로를 대체)
export function buildResourceUrl(relPath) {
  if (!relPath) return relPath;
  return `${CDN_HOST}/resources/${relPath}`;
}

// cmd 인자 → 리소스 절대 URL 해석.
//  - arg 가 문자열: 레거시(글로벌 fileName) → resources/{subfolder}/{name}
//  - arg.targetKey 존재: 사용자 리소스 등 전체 키(users/{uid}/...) → CDN 호스트만 붙임
//  - arg.targetFileName: 글로벌 fileName → resources/{subfolder}/{name}
//  subfolder 예: "sounds" | "musics" | "lotties/background" | "gifs"
export function resolveResourceUrl(arg, subfolder = "") {
  if (arg == null) return arg;
  if (typeof arg === "string") {
    return subfolder ? buildResourceUrl(`${subfolder}/${arg}`) : buildResourceUrl(arg);
  }
  if (arg.targetKey) return `${CDN_HOST}/${arg.targetKey}`;
  const name = arg.targetFileName;
  if (!name) return null;
  return subfolder ? buildResourceUrl(`${subfolder}/${name}`) : buildResourceUrl(name);
}

// WILL DEPRECATE
export const ALL_ACTION_IDS = [
  "animation--agree",
  "animation--angry",
  "animation--deahat",
  "animation--die",
  "animation--embarrassment",
  "animation--happy",
  "animation--hi",
  "animation--thankyou",
];

// TODO: duplicate code with Home.vue
function transformText(animationId) {
  try {
    const [type, id] = animationId.split("--");
    if (type === "animation") {
      if (id === "Root|740428|BaseLayer".toLowerCase()) return "하암 !@!";
      else if (id === "dance") return "댄스타임";
      else if (id === "hi") return "안녕하세요 :)";
      else if (id === "deahat") return "데햇 >.<";
      else if (id === "die") return "죽는다!!";
      else if (id === "agree") return "동의하는 바이오";
      else if (id === "angry") return "매우 화남";
      else if (id === "embarrassment") return "화들짝";
      else if (id === "happy") return "행복해^^";
      else if (id === "thankyou") return "감사합니다";
    } else if (type === "camera") {
      if (id === "restore") return "카메라 복구";
    }

    return id;
  } catch (error) {
    console.log(error);
    return "-";
  }
}

// split id and transform text
export const ALL_ANIMATION = ALL_ACTION_IDS.map((animationId) => ({
  id: animationId,
  value: animationId,
  text: transformText(animationId),
}));
